"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeCSSLifecycles = void 0;
function mergeCSSLifecycles(...args) {
    return {
        bootstrap: (config) => Promise.all(args.map((lifecycle) => lifecycle.bootstrap(config))),
        mount: (config) => Promise.all(args.map((lifecycle) => lifecycle.mount(config))),
        unmount: (config) => Promise.all(args.map((lifecycle) => lifecycle.unmount(config)))
    };
}
exports.mergeCSSLifecycles = mergeCSSLifecycles;
